export const E_API_KEY = Object.freeze({
  MAIN: "/api-key",
  DETAIL: "/api-key/:id",
});
